import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

export const ModalRegisterByInvitation = ({ isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size='md' className='close-circle'>
            <ModalHeader toggle={toggle} className='justify-content-center border-0 pb-0' />
            <ModalBody className='text-center'>
                <p className='mb-4'>
                    Adding users to this account is by individual invite only. For further inquiries please contact your local business admin or{' '}
                    <Link to="/contact-us" className="text-primary font-weight-semibold" onClick={toggle}>
                        contact us here.
                    </Link>
                </p>
                <Button color='green-light' size='sm' onClick={toggle}>I Understand</Button>
            </ModalBody>
        </Modal>
    );
};
